import { Ripple } from "@/shared/ui/Ripple";

export class QuantityInput {
    private $element: JQuery;
    private $value: JQuery;
    private $decreaseBtn: JQuery;
    private $increaseBtn: JQuery;

    private currentValue: number = 1;

    private min?: number;
    private max?: number;

    public onChange?: { () };

    constructor(min?: number, max?: number) {
        this.$element = $('<div class="quantityinput" />');

        this.min = min;
        this.max = max;

        this.$decreaseBtn = $('<button class="circlebutton decrease"><i class="fal fa-minus"></i></button>').appendTo(
            this.$element
        );
        Ripple.bind(
            this.$decreaseBtn.click((e) => {
                if ($(e.currentTarget).is(":disabled")) return false;

                this.currentValue--;
                this.$value.html(this.currentValue + "");
                this.checkButtonState();

                if (this.onChange !== undefined) this.onChange();
            })
        );

        this.$value = $('<div class="value">' + this.currentValue + "</div>").appendTo(this.$element);
        this.$increaseBtn = $('<button class="circlebutton increase"><i class="fal fa-plus"></i></button>').appendTo(
            this.$element
        );
        Ripple.bind(
            this.$increaseBtn.click((e) => {
                if ($(e.currentTarget).is(":disabled")) return false;

                this.currentValue++;
                this.$value.html(this.currentValue + "");
                this.checkButtonState();

                if (this.onChange !== undefined) this.onChange();
            })
        );
    }

    public getValue(): number {
        return this.currentValue;
    }

    public setValue(va: number): QuantityInput {
        if (this.min !== undefined && va < this.min) va = this.min;

        if (this.max !== undefined && va > this.max) va = this.max;

        this.currentValue = va;
        this.$value.html(this.currentValue + "");
        this.checkButtonState();

        return this;
    }

    public setMin(va: number): QuantityInput {
        this.min = va;
        if (this.min !== undefined && this.currentValue < this.min) this.setValue(this.min);
        return this;
    }

    public setMax(va: number): QuantityInput {
        this.max = va;
        if (this.max !== undefined && this.max < this.currentValue) this.setValue(this.max);
        return this;
    }

    public appendTo($element: JQuery): QuantityInput {
        this.$element.appendTo($element);

        return this;
    }

    public show() {
        this.$element.removeClass("invisible");
    }

    public hide() {
        this.$element.addClass("invisible");
    }

    private checkButtonState() {
        this.$decreaseBtn.prop("disabled", this.min !== undefined && this.currentValue <= this.min);
        this.$increaseBtn.prop("disabled", this.max !== undefined && this.currentValue >= this.max);
    }
}
